<template>
  <div id="app">
    <notifications/>

    <router-view></router-view>
  </div>
</template>

<script>
// import { parseJwt } from '@/services/jwt.service';
import JwtService from '@/services/jwt.service';
import ApiService from '@/services/api.service';
import { mapState, mapMutations } from 'vuex';
// import {get} from "@/services/api.service";

export default {
  name: 'App',
  data() {
    return {
      token: JwtService.parseJwt(),
      assessment: null,
    };
  },
  computed: {
    ...mapState(['currentUser', 'currentDealership', 'currentPriority', 'currentBenchmarks', 'scs']),
  },
  created() {
    this.loadCurrentUser();
    this.loadCurrentDealership();
    this.loadCurrentPriority();
    this.loadCurrentBenchmarks();
    // this.setCurrentDealership('test');
  },
  methods: {
    ...mapMutations(['setCurrentUser', 'setCurrentDealership', 'setCurrentPriority', 'setCurrentBenchmarks', 'setCurrentAssessment', 'setSCS']),
    getSCSInfo(dealer) {
      if (dealer !== null) {
        ApiService.get(`api/v1/assessments`, `scs_info?dealer=${dealer.code}`).then((data) => {
          this.setSCS(data.data);
        });
      }
    },
    loadCurrentUser() {
      if (this.token) {
        ApiService.get(`api/v1/users/${this.token.sub}`).then((data) => {
          console.debug(`Loaded session for User ${data.data.id}`)
          this.setCurrentUser(data.data);
        });
      }
    },
    loadCurrentDealership() {
      var dealership = localStorage.getItem('selected_dealership') || null
      if (dealership === "null" || dealership === null) {
        dealership = null
        console.debug("No dealership selected")
      } else {
        dealership = JSON.parse(dealership)
        console.debug(`Dealership "${dealership.label}" selected`)
      }
      this.setCurrentDealership(dealership);
      this.getSCSInfo(dealership);
    },
    loadCurrentPriority() {
      let priority = localStorage.getItem('priority') || null
      if (priority === "null" || priority === null) {
        priority = null
        console.debug("No priority selected")
      } else {
        console.debug(`Priority "${priority}" selected`)
      }
      this.setCurrentPriority(priority);
    },
    loadCurrentBenchmarks() {
      var form = JSON.parse(localStorage.getItem('assessmentForm')) || null

      if (form === "null" || form === null) {
        form = null
        console.debug("No previous from data found");
        this.setCurrentBenchmarks(null);
      } else {
        console.debug("Loading previous from data");
        // console.log(form);

        var benchmarks = [
          {
            name: "Compensation",
            key: "compensation",
            categories: [
              {
                name: "Annual Income",
                key: "c1",
                checked: [
                  // "assessmentForm.compensation.c1.q1",
                  // "assessmentForm.compensation.c1.q2",
                  // "assessmentForm.compensation.c1.q3",
                  // "uncheckAll",
                ]
              },{
                name: "Pay Plan Methodology and Bonus Structure",
                key: "c2",
                checked: [
                  // "assessmentForm.compensation.c2.q1",
                  // "assessmentForm.compensation.c2.q2",
                  // "assessmentForm.compensation.c2.q3",
                  // "uncheckAll",
                ]
              },{
                name: "Benefits",
                key: "c3",
                checked: [
                  // "assessmentForm.compensation.c3.q1",
                  // "assessmentForm.compensation.c3.q2",
                  // "assessmentForm.compensation.c3.q3",
                  // "uncheckAll",
                ]
              },
            ]
          },{
            name: "Training",
            key: "training",
            categories: [
              {
                name: "Onboarding Process",
                key: "c1",
                checked: [
                  // "assessmentForm.training.c1.q1",
                  // "assessmentForm.training.c1.q2",
                  // "assessmentForm.training.c1.q3",
                ]
              },{
                name: "Training Class Policies",
                key: "c2",
                checked: [
                  // "assessmentForm.training.c2.q1",
                  // "assessmentForm.training.c2.q2",
                  // "assessmentForm.training.c2.q3",
                ]
              },{
                name: "Career Planning",
                key: "c3",
                checked: [
                  // "assessmentForm.training.c3.q1",
                  // "assessmentForm.training.c3.q2",
                  // "assessmentForm.training.c3.q3",
                ]
              },{
                name: "Mentorship Programs",
                key: "c4",
                checked: [
                  // "assessmentForm.training.c4.q1",
                  // "assessmentForm.training.c4.q2",
                  // "assessmentForm.training.c4.q3",
                ]
              },
            ]
          },{
            name: "Management",
            key: "management",
            categories: [
              {
                name: "Meeting Schedule",
                key: "c1",
                checked: [
                  // "assessmentForm.management.c1.q1",
                  // "assessmentForm.management.c1.q2",
                  // "assessmentForm.management.c1.q3",
                ]
              },{
                name: "Error Policy",
                key: "c2",
                checked: [
                  // "assessmentForm.management.c2.q1",
                  // "assessmentForm.management.c2.q2",
                  // "assessmentForm.management.c2.q3",
                ]
              },{
                name: "Feedback Mechanisms",
                key: "c3",
                checked: [
                  // "assessmentForm.management.c3.q1",
                  // "assessmentForm.management.c3.q2",
                  // "assessmentForm.management.c3.q3",
                ]
              }
            ]
          },{
            name: "Dealer Conditions",
            key: "dealerConditions",
            categories: [
              {
                name: "Dispatch Methods",
                key: "c1",
                checked: [
                  // "assessmentForm.dealerConditions.c1.q1",
                  // "assessmentForm.dealerConditions.c1.q2",
                  // "assessmentForm.dealerConditions.c1.q3",
                ]
              },{
                name: "Work Processes",
                key: "c2",
                checked: [
                  // "assessmentForm.dealerConditions.c2.q1",
                  // "assessmentForm.dealerConditions.c2.q2",
                  // "assessmentForm.dealerConditions.c2.q3",
                ]
              },{
                name: "Facility Standards",
                key: "c3",
                checked: [
                  // "assessmentForm.dealerConditions.c3.q1",
                  // "assessmentForm.dealerConditions.c3.q2",
                  // "assessmentForm.dealerConditions.c3.q3",
                ]
              },{
                name: "Dealership Culture",
                key: "c4",
                checked: [
                  // "assessmentForm.dealerConditions.c4.q1",
                  // "assessmentForm.dealerConditions.c4.q2",
                  // "assessmentForm.dealerConditions.c4.q3",
                ]
              },
            ]
          },{
            name: "Rewards & Recognition",
            key: "rewards",
            categories: [
              {
                name: "Rewards Programs and Special Bonuses",
                key: "c1",
                checked: [
                  // "assessmentForm.rewards.c1.q1",
                  // "assessmentForm.rewards.c1.q2",
                  // "assessmentForm.rewards.c1.q3",
                ]
              },{
                name: "Workday Perks",
                key: "c2",
                checked: [
                  // "assessmentForm.rewards.c2.q1",
                  // "assessmentForm.rewards.c2.q2",
                  // "assessmentForm.rewards.c2.q3",
                ]
              },{
                name: "Tenure Benefits",
                key: "c3",
                checked: [
                  // "assessmentForm.rewards.c3.q1",
                  // "assessmentForm.rewards.c3.q2",
                  // "assessmentForm.rewards.c3.q3",
                ]
              },
            ]
          }
        ]

        if (form["assessmentForm.compensation.c1"].includes("assessmentForm.compensation.c1.q1")) benchmarks[0].categories[0].checked.push("assessmentForm.compensation.c1.q1")
        if (form["assessmentForm.compensation.c1"].includes("assessmentForm.compensation.c1.q2")) benchmarks[0].categories[0].checked.push("assessmentForm.compensation.c1.q2")
        if (form["assessmentForm.compensation.c1"].includes("assessmentForm.compensation.c1.q3")) benchmarks[0].categories[0].checked.push("assessmentForm.compensation.c1.q3")
        if (form["assessmentForm.compensation.c1"].includes("uncheckAll")) benchmarks[0].categories[0].checked.push("uncheckAll")
        if (form["assessmentForm.compensation.c2"].includes("assessmentForm.compensation.c2.q1")) benchmarks[0].categories[1].checked.push("assessmentForm.compensation.c2.q1")
        if (form["assessmentForm.compensation.c2"].includes("assessmentForm.compensation.c2.q2")) benchmarks[0].categories[1].checked.push("assessmentForm.compensation.c2.q2")
        if (form["assessmentForm.compensation.c2"].includes("assessmentForm.compensation.c2.q3")) benchmarks[0].categories[1].checked.push("assessmentForm.compensation.c2.q3")
        if (form["assessmentForm.compensation.c2"].includes("uncheckAll")) benchmarks[0].categories[1].checked.push("uncheckAll")
        if (form["assessmentForm.compensation.c3"].includes("assessmentForm.compensation.c3.q1")) benchmarks[0].categories[2].checked.push("assessmentForm.compensation.c3.q1")
        if (form["assessmentForm.compensation.c3"].includes("assessmentForm.compensation.c3.q2")) benchmarks[0].categories[2].checked.push("assessmentForm.compensation.c3.q2")
        if (form["assessmentForm.compensation.c3"].includes("assessmentForm.compensation.c3.q3")) benchmarks[0].categories[2].checked.push("assessmentForm.compensation.c3.q3")
        if (form["assessmentForm.compensation.c3"].includes("uncheckAll")) benchmarks[0].categories[2].checked.push("uncheckAll")

        if (form["assessmentForm.training.c1"].includes("assessmentForm.training.c1.q1")) benchmarks[1].categories[0].checked.push("assessmentForm.training.c1.q1")
        if (form["assessmentForm.training.c1"].includes("assessmentForm.training.c1.q2")) benchmarks[1].categories[0].checked.push("assessmentForm.training.c1.q2")
        if (form["assessmentForm.training.c1"].includes("assessmentForm.training.c1.q3")) benchmarks[1].categories[0].checked.push("assessmentForm.training.c1.q3")
        if (form["assessmentForm.training.c1"].includes("uncheckAll")) benchmarks[1].categories[0].checked.push("uncheckAll")
        if (form["assessmentForm.training.c2"].includes("assessmentForm.training.c2.q1")) benchmarks[1].categories[1].checked.push("assessmentForm.training.c2.q1")
        if (form["assessmentForm.training.c2"].includes("assessmentForm.training.c2.q2")) benchmarks[1].categories[1].checked.push("assessmentForm.training.c2.q2")
        if (form["assessmentForm.training.c2"].includes("assessmentForm.training.c2.q3")) benchmarks[1].categories[1].checked.push("assessmentForm.training.c2.q3")
        if (form["assessmentForm.training.c2"].includes("uncheckAll")) benchmarks[1].categories[1].checked.push("uncheckAll")
        if (form["assessmentForm.training.c3"].includes("assessmentForm.training.c3.q1")) benchmarks[1].categories[2].checked.push("assessmentForm.training.c3.q1")
        if (form["assessmentForm.training.c3"].includes("assessmentForm.training.c3.q2")) benchmarks[1].categories[2].checked.push("assessmentForm.training.c3.q2")
        if (form["assessmentForm.training.c3"].includes("assessmentForm.training.c3.q3")) benchmarks[1].categories[2].checked.push("assessmentForm.training.c3.q3")
        if (form["assessmentForm.training.c3"].includes("uncheckAll")) benchmarks[1].categories[2].checked.push("uncheckAll")
        if (form["assessmentForm.training.c4"].includes("assessmentForm.training.c4.q1")) benchmarks[1].categories[3].checked.push("assessmentForm.training.c4.q1")
        if (form["assessmentForm.training.c4"].includes("assessmentForm.training.c4.q2")) benchmarks[1].categories[3].checked.push("assessmentForm.training.c4.q2")
        if (form["assessmentForm.training.c4"].includes("assessmentForm.training.c4.q3")) benchmarks[1].categories[3].checked.push("assessmentForm.training.c4.q3")
        if (form["assessmentForm.training.c4"].includes("uncheckAll")) benchmarks[1].categories[3].checked.push("uncheckAll")

        if (form["assessmentForm.management.c1"].includes("assessmentForm.management.c1.q1")) benchmarks[2].categories[0].checked.push("assessmentForm.management.c1.q1")
        if (form["assessmentForm.management.c1"].includes("assessmentForm.management.c1.q2")) benchmarks[2].categories[0].checked.push("assessmentForm.management.c1.q2")
        if (form["assessmentForm.management.c1"].includes("assessmentForm.management.c1.q3")) benchmarks[2].categories[0].checked.push("assessmentForm.management.c1.q3")
        if (form["assessmentForm.management.c1"].includes("uncheckAll")) benchmarks[2].categories[0].checked.push("uncheckAll")
        if (form["assessmentForm.management.c2"].includes("assessmentForm.management.c2.q1")) benchmarks[2].categories[1].checked.push("assessmentForm.management.c2.q1")
        if (form["assessmentForm.management.c2"].includes("assessmentForm.management.c2.q2")) benchmarks[2].categories[1].checked.push("assessmentForm.management.c2.q2")
        if (form["assessmentForm.management.c2"].includes("assessmentForm.management.c2.q3")) benchmarks[2].categories[1].checked.push("assessmentForm.management.c2.q3")
        if (form["assessmentForm.management.c2"].includes("uncheckAll")) benchmarks[2].categories[1].checked.push("uncheckAll")
        if (form["assessmentForm.management.c3"].includes("assessmentForm.management.c3.q1")) benchmarks[2].categories[2].checked.push("assessmentForm.management.c3.q1")
        if (form["assessmentForm.management.c3"].includes("assessmentForm.management.c3.q2")) benchmarks[2].categories[2].checked.push("assessmentForm.management.c3.q2")
        if (form["assessmentForm.management.c3"].includes("assessmentForm.management.c3.q3")) benchmarks[2].categories[2].checked.push("assessmentForm.management.c3.q3")
        if (form["assessmentForm.management.c3"].includes("uncheckAll")) benchmarks[2].categories[2].checked.push("uncheckAll")

        if (form["assessmentForm.dealerConditions.c1"].includes("assessmentForm.dealerConditions.c1.q1")) benchmarks[3].categories[0].checked.push("assessmentForm.dealerConditions.c1.q1")
        if (form["assessmentForm.dealerConditions.c1"].includes("assessmentForm.dealerConditions.c1.q2")) benchmarks[3].categories[0].checked.push("assessmentForm.dealerConditions.c1.q2")
        if (form["assessmentForm.dealerConditions.c1"].includes("assessmentForm.dealerConditions.c1.q3")) benchmarks[3].categories[0].checked.push("assessmentForm.dealerConditions.c1.q3")
        if (form["assessmentForm.dealerConditions.c1"].includes("uncheckAll")) benchmarks[3].categories[0].checked.push("uncheckAll")
        if (form["assessmentForm.dealerConditions.c2"].includes("assessmentForm.dealerConditions.c2.q1")) benchmarks[3].categories[1].checked.push("assessmentForm.dealerConditions.c2.q1")
        if (form["assessmentForm.dealerConditions.c2"].includes("assessmentForm.dealerConditions.c2.q2")) benchmarks[3].categories[1].checked.push("assessmentForm.dealerConditions.c2.q2")
        if (form["assessmentForm.dealerConditions.c2"].includes("assessmentForm.dealerConditions.c2.q3")) benchmarks[3].categories[1].checked.push("assessmentForm.dealerConditions.c2.q3")
        if (form["assessmentForm.dealerConditions.c2"].includes("uncheckAll")) benchmarks[3].categories[1].checked.push("uncheckAll")
        if (form["assessmentForm.dealerConditions.c3"].includes("assessmentForm.dealerConditions.c3.q1")) benchmarks[3].categories[2].checked.push("assessmentForm.dealerConditions.c3.q1")
        if (form["assessmentForm.dealerConditions.c3"].includes("assessmentForm.dealerConditions.c3.q2")) benchmarks[3].categories[2].checked.push("assessmentForm.dealerConditions.c3.q2")
        if (form["assessmentForm.dealerConditions.c3"].includes("assessmentForm.dealerConditions.c3.q3")) benchmarks[3].categories[2].checked.push("assessmentForm.dealerConditions.c3.q3")
        if (form["assessmentForm.dealerConditions.c3"].includes("uncheckAll")) benchmarks[3].categories[2].checked.push("uncheckAll")
        if (form["assessmentForm.dealerConditions.c4"].includes("assessmentForm.dealerConditions.c4.q1")) benchmarks[3].categories[3].checked.push("assessmentForm.dealerConditions.c4.q1")
        if (form["assessmentForm.dealerConditions.c4"].includes("assessmentForm.dealerConditions.c4.q2")) benchmarks[3].categories[3].checked.push("assessmentForm.dealerConditions.c4.q2")
        if (form["assessmentForm.dealerConditions.c4"].includes("assessmentForm.dealerConditions.c4.q3")) benchmarks[3].categories[3].checked.push("assessmentForm.dealerConditions.c4.q3")
        if (form["assessmentForm.dealerConditions.c4"].includes("uncheckAll")) benchmarks[3].categories[3].checked.push("uncheckAll")

        if (form["assessmentForm.rewards.c1"].includes("assessmentForm.rewards.c1.q1")) benchmarks[4].categories[0].checked.push("assessmentForm.rewards.c1.q1")
        if (form["assessmentForm.rewards.c1"].includes("assessmentForm.rewards.c1.q2")) benchmarks[4].categories[0].checked.push("assessmentForm.rewards.c1.q2")
        if (form["assessmentForm.rewards.c1"].includes("assessmentForm.rewards.c1.q3")) benchmarks[4].categories[0].checked.push("assessmentForm.rewards.c1.q3")
        if (form["assessmentForm.rewards.c1"].includes("uncheckAll")) benchmarks[4].categories[0].checked.push("uncheckAll")
        if (form["assessmentForm.rewards.c2"].includes("assessmentForm.rewards.c2.q1")) benchmarks[4].categories[1].checked.push("assessmentForm.rewards.c2.q1")
        if (form["assessmentForm.rewards.c2"].includes("assessmentForm.rewards.c2.q2")) benchmarks[4].categories[1].checked.push("assessmentForm.rewards.c2.q2")
        if (form["assessmentForm.rewards.c2"].includes("assessmentForm.rewards.c2.q3")) benchmarks[4].categories[1].checked.push("assessmentForm.rewards.c2.q3")
        if (form["assessmentForm.rewards.c2"].includes("uncheckAll")) benchmarks[4].categories[1].checked.push("uncheckAll")
        if (form["assessmentForm.rewards.c3"].includes("assessmentForm.rewards.c3.q1")) benchmarks[4].categories[2].checked.push("assessmentForm.rewards.c3.q1")
        if (form["assessmentForm.rewards.c3"].includes("assessmentForm.rewards.c3.q2")) benchmarks[4].categories[2].checked.push("assessmentForm.rewards.c3.q2")
        if (form["assessmentForm.rewards.c3"].includes("assessmentForm.rewards.c3.q3")) benchmarks[4].categories[2].checked.push("assessmentForm.rewards.c3.q3")
        if (form["assessmentForm.rewards.c3"].includes("uncheckAll")) benchmarks[4].categories[2].checked.push("uncheckAll")


        this.setCurrentBenchmarks(benchmarks);
      }
    },
    findOrCreateAssessment() {
      const params = {
        'query[s]': 'updated_at desc',
        'query[dealership_eq]': this.currentDealership.name.replace('\'', ''),
        'query[completed_false]': 1,
        per_page: 1
      };
      ApiService.query('api/v1/assessments', { params })
        .then((data) => {
          if (data.data.length > 0) {
            this.assessment = data.data[0];
            this.setCurrentAssessment(this.assessment);
            this.formSelections = data.data[0].form_checkboxes;
            if (this.formSelections !== null) {
              localStorage.setItem('assessmentForm', JSON.stringify(this.formSelections));
              this.loadCurrentBenchmarks();
            } else {
              this.formSelections = {}

              let form = {
                "assessmentForm.compensation.c1": [],
                "assessmentForm.compensation.c2": [],
                "assessmentForm.compensation.c3": [],
                "assessmentForm.training.c1": [],
                "assessmentForm.training.c2": [],
                "assessmentForm.training.c3": [],
                "assessmentForm.training.c4": [],
                "assessmentForm.management.c1": [],
                "assessmentForm.management.c2": [],
                "assessmentForm.management.c3": [],
                "assessmentForm.dealerConditions.c1": [],
                "assessmentForm.dealerConditions.c2": [],
                "assessmentForm.dealerConditions.c3": [],
                "assessmentForm.dealerConditions.c4": [],
                "assessmentForm.rewards.c1": [],
                "assessmentForm.rewards.c2": [],
                "assessmentForm.rewards.c3": [],
              }

              this.formSelections = form;

              var benchmarks = [
                {
                  name: "Compensation",
                  key: "compensation",
                  categories: [
                    {
                      name: "Annual Income",
                      key: "c1",
                      checked: [
                        // "assessmentForm.compensation.c1.q1",
                        // "assessmentForm.compensation.c1.q2",
                        // "assessmentForm.compensation.c1.q3",
                        // "uncheckAll",
                      ]
                    },{
                      name: "Pay Plan Methodology and Bonus Structure",
                      key: "c2",
                      checked: [
                        // "assessmentForm.compensation.c2.q1",
                        // "assessmentForm.compensation.c2.q2",
                        // "assessmentForm.compensation.c2.q3",
                        // "uncheckAll",
                      ]
                    },{
                      name: "Benefits",
                      key: "c3",
                      checked: [
                        // "assessmentForm.compensation.c3.q1",
                        // "assessmentForm.compensation.c3.q2",
                        // "assessmentForm.compensation.c3.q3",
                        // "uncheckAll",
                      ]
                    },
                  ]
                },{
                  name: "Training",
                  key: "training",
                  categories: [
                    {
                      name: "Onboarding Process",
                      key: "c1",
                      checked: [
                        // "assessmentForm.training.c1.q1",
                        // "assessmentForm.training.c1.q2",
                        // "assessmentForm.training.c1.q3",
                      ]
                    },{
                      name: "Training Class Policies",
                      key: "c2",
                      checked: [
                        // "assessmentForm.training.c2.q1",
                        // "assessmentForm.training.c2.q2",
                        // "assessmentForm.training.c2.q3",
                      ]
                    },{
                      name: "Career Planning",
                      key: "c3",
                      checked: [
                        // "assessmentForm.training.c3.q1",
                        // "assessmentForm.training.c3.q2",
                        // "assessmentForm.training.c3.q3",
                      ]
                    },{
                      name: "Mentorship Programs",
                      key: "c4",
                      checked: [
                        // "assessmentForm.training.c4.q1",
                        // "assessmentForm.training.c4.q2",
                        // "assessmentForm.training.c4.q3",
                      ]
                    },
                  ]
                },{
                  name: "Management",
                  key: "management",
                  categories: [
                    {
                      name: "Meeting Schedule",
                      key: "c1",
                      checked: [
                        // "assessmentForm.management.c1.q1",
                        // "assessmentForm.management.c1.q2",
                        // "assessmentForm.management.c1.q3",
                      ]
                    },{
                      name: "Error Policy",
                      key: "c2",
                      checked: [
                        // "assessmentForm.management.c2.q1",
                        // "assessmentForm.management.c2.q2",
                        // "assessmentForm.management.c2.q3",
                      ]
                    },{
                      name: "Feedback Mechanisms",
                      key: "c3",
                      checked: [
                        // "assessmentForm.management.c3.q1",
                        // "assessmentForm.management.c3.q2",
                        // "assessmentForm.management.c3.q3",
                      ]
                    }
                  ]
                },{
                  name: "Dealer Conditions",
                  key: "dealerConditions",
                  categories: [
                    {
                      name: "Dispatch Methods",
                      key: "c1",
                      checked: [
                        // "assessmentForm.dealerConditions.c1.q1",
                        // "assessmentForm.dealerConditions.c1.q2",
                        // "assessmentForm.dealerConditions.c1.q3",
                      ]
                    },{
                      name: "Work Processes",
                      key: "c2",
                      checked: [
                        // "assessmentForm.dealerConditions.c2.q1",
                        // "assessmentForm.dealerConditions.c2.q2",
                        // "assessmentForm.dealerConditions.c2.q3",
                      ]
                    },{
                      name: "Facility Standards",
                      key: "c3",
                      checked: [
                        // "assessmentForm.dealerConditions.c3.q1",
                        // "assessmentForm.dealerConditions.c3.q2",
                        // "assessmentForm.dealerConditions.c3.q3",
                      ]
                    },{
                      name: "Dealership Culture",
                      key: "c4",
                      checked: [
                        // "assessmentForm.dealerConditions.c4.q1",
                        // "assessmentForm.dealerConditions.c4.q2",
                        // "assessmentForm.dealerConditions.c4.q3",
                      ]
                    },
                  ]
                },{
                  name: "Rewards & Recognition",
                  key: "rewards",
                  categories: [
                    {
                      name: "Rewards Programs and Special Bonuses",
                      key: "c1",
                      checked: [
                        // "assessmentForm.rewards.c1.q1",
                        // "assessmentForm.rewards.c1.q2",
                        // "assessmentForm.rewards.c1.q3",
                      ]
                    },{
                      name: "Workday Perks",
                      key: "c2",
                      checked: [
                        // "assessmentForm.rewards.c2.q1",
                        // "assessmentForm.rewards.c2.q2",
                        // "assessmentForm.rewards.c2.q3",
                      ]
                    },{
                      name: "Tenure Benefits",
                      key: "c3",
                      checked: [
                        // "assessmentForm.rewards.c3.q1",
                        // "assessmentForm.rewards.c3.q2",
                        // "assessmentForm.rewards.c3.q3",
                      ]
                    },
                  ]
                }
              ]
              this.setCurrentBenchmarks(benchmarks);

              this.ready = true;
            }
          } else {
            let form = {
              "assessmentForm.compensation.c1": [],
              "assessmentForm.compensation.c2": [],
              "assessmentForm.compensation.c3": [],
              "assessmentForm.training.c1": [],
              "assessmentForm.training.c2": [],
              "assessmentForm.training.c3": [],
              "assessmentForm.training.c4": [],
              "assessmentForm.management.c1": [],
              "assessmentForm.management.c2": [],
              "assessmentForm.management.c3": [],
              "assessmentForm.dealerConditions.c1": [],
              "assessmentForm.dealerConditions.c2": [],
              "assessmentForm.dealerConditions.c3": [],
              "assessmentForm.dealerConditions.c4": [],
              "assessmentForm.rewards.c1": [],
              "assessmentForm.rewards.c2": [],
              "assessmentForm.rewards.c3": [],
            }

            const oldParams = {
              'query[s]': 'updated_at desc',
              'query[dealership_eq]': this.currentDealership.name.replace('\'', ''),
              'query[completed_false]': 0,
              per_page: 1
            };
            ApiService.query('api/v1/assessments', { params: oldParams })
              .then((data) => {
                let newParams = {}
                if (data.data.length === 0) {
                  newParams = {
                    assessment: {
                      benchmarks: {},
                      dealership: this.currentDealership.name.replace('\'', ''),
                      form_checkboxes: form,
                    }
                  }
                } else {
                  newParams = {
                    assessment: {
                      benchmarks: data.data[0].benchmarks,
                      dealership: this.currentDealership.name.replace('\'', ''),
                      form_checkboxes: data.data[0].form_checkboxes,
                      priority: data.data[0].priority,
                      priority_checkboxes: data.data[0].priority_checkboxes,
                      action_plan: data.data[0].action_plan,
                    },
                  }
                }

                console.log(newParams)

                ApiService.post('api/v1/assessments', newParams)
                  .then((data) => {
                    this.assessment = data.data;
                    this.setCurrentAssessment(this.assessment);
                    localStorage.setItem('assessmentForm', JSON.stringify(form))
                    console.log(data.data);
                    this.loadCurrentBenchmarks();
                  })
              })



          }
        });
    },
  },
  watch: {
    currentDealership(newValue) {
      if (newValue !== null) {
        this.findOrCreateAssessment();
      }
    }
  }
}
</script>

<style>
  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    /*text-align: center;*/
    color: #2c3e50;
  }
  html, body, #app {
    height: 100%;
    overflow: hidden;
  }
</style>
